interface Props {
}

export const ErrorPage = (props: Props) => {
    return (
    <div className="aq-content">
        <h3>An unexpected error occured</h3>
        Please go back and try again.
    </div>
    );
};